export default __webpack_public_path__ + "static/Effra_Rg-16903bd59c24db0af49c90747db12950.ttf";